import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlightPositionalInformation from './FlightPositionalInformation';
import componentBase from '../../../../../../../../src/lib/component-base';

@componentBase('FlightPositionalInformationContainer')
export default class FlightPositionalInformationContainer extends Component {
  static propTypes = {
    flight: PropTypes.object,
    params: PropTypes.object,
  };

  render() {
    const { flight, params } = this.props;

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <FlightPositionalInformation
          flight={flight}
          params={params}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/container.js